// extracted by mini-css-extract-plugin
export default {"ActionList_GroupHeading":"RelationshipsSection-module__ActionList_GroupHeading--BdSOR"};